import { useEffect, useState } from 'react';
import type { ReactElement } from 'react';
import { formatCountdown } from '../lib/format';

/**
 * Ticks once a second under a day, once a minute above. Nothing here schedules
 * work: iOS suspends timers as soon as the app is backgrounded, and the value is
 * recomputed from the clock on every render.
 */
export function Countdown({ target }: { target: Date }): ReactElement {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const remaining = target.getTime() - Date.now();
    const period = remaining > 86_400_000 ? 30_000 : 1000;
    const id = setInterval(() => setNow(Date.now()), period);
    return () => clearInterval(id);
  }, [target]);

  return <span className="tabular">{formatCountdown(target.getTime() - now)}</span>;
}
